import React from "react";

export default function VideoProgressBar({ media, videoDuration }) {

  /**
   * The setTime function will set the amount of time the video has been playing
   * for, and display both the elapsed time and a video progress bar on screen
   * for the user to see.
   */
  const setTime = () => {
    const minutes = Math.floor(media.currentTime / 60);
    const seconds = Math.floor(media.currentTime - minutes * 60);

    let minutesText;
    let secondsText;

    if (minutes < 10) {
      minutesText = '0' + minutes;
    } else {
      minutesText = minutes;
    }

    if (seconds < 10) {
      secondsText = '0' + seconds;
    } else {
      secondsText = seconds;
    }

    let duration = videoDuration;

    if (media.duration != "Infinity" && media.duration != NaN) {
      duration = media.duration;
    }

    const mediaTime = minutesText + ':' + secondsText;
    if (document.querySelector('.gc__progress_bar_time')) {
      document.querySelector('.gc__progress_bar_time').innerHTML = mediaTime;
    }

    if (document.querySelector('.gc__progress_bar_container')) {
      let barLength = document.querySelector('.gc__progress_bar_container').clientWidth * (media.currentTime/duration);
      document.querySelector('.gc__progress_bar_progress').style.width = barLength + 'px';
    }
  }

  media?.addEventListener('timeupdate', setTime);

  return (
    <div className={"gc__progress_bar_container"}>
      <span className={"gc__progress_bar_time"}>00.00</span>
      <div className={"gc__progress_bar"}>
        <div className={"gc__progress_bar_progress"}><p></p></div>
      </div>
    </div>
  )
}
